interface ScrollPosition {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
}

export const isScrolledToBottom = ({
  scrollTop,
  clientHeight,
  scrollHeight,
}: ScrollPosition): boolean => scrollTop + clientHeight >= scrollHeight;
